import React from 'react'
import PropTypes from 'prop-types'
import {DASH, formatDurationHMS, formatInt} from '../../helpers/format'

/**
 * Giờ định mức — 2 dòng: dòng chính `Xh YYm ZZs`, dòng dưới là hint số giây NGUYÊN (SCR-M18-002).
 * Tách thành component chung vì cách hiển thị này (giá trị chính + hint mờ bên dưới) dùng lại được
 * ở bất cứ đâu cần trình bày thời lượng theo giây, không chỉ riêng bảng chi tiết sản lượng.
 */
function Duration({seconds}) {
    if (seconds === null || seconds === undefined) {
        return <span className="VcMuted">{DASH}</span>
    }

    return (
        <div className="VcDuration">
            <div>{formatDurationHMS(seconds)}</div>
            <div className="VcMuted VcDuration__hint">{formatInt(Math.round(Number(seconds)))}s</div>
        </div>
    )
}

Duration.propTypes = {
    /** Số giây. `null`/`undefined` → hiện dấu gạch, KHÔNG phải `0`. */
    seconds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Duration
